export const convertToReal = (prefix, cents) => {
    const reais = cents / 100; // Divide o valor em centavos por 100 para obter o valor em reais
    return prefix + reais.toFixed(2); // Formata o valor em reais com duas casas decimais
};
